// Demo/tutorial video shown by the "Video Guide" button (main canvas header).
// Paste a YouTube link (watch / youtu.be / embed all work) or a direct .mp4 URL.
export const VIDEO_GUIDE_DESKTOP_URL = 'https://www.youtube.com/embed/A1EzlWbAqNE';
export const VIDEO_GUIDE_MOBILE_URL = 'https://www.youtube.com/embed/2I8Hu0m0ils';

// Separate video shown by the "watch now" link inside the "Action Required"
// alert (Boundary + Measurement setup) — its own video, not the same as the
// main Video Guide button above.
export const ACTION_REQUIRED_VIDEO_URL = 'https://www.youtube.com/embed/KwOpEwXExaU';

// "Floor Plan Maker" button (canvas toolbar) opens this site in a new tab.
export const FLOOR_PLAN_MAKER_URL = 'https://www.vastuanalyzer.com/floor-plan-maker/';

// "Floor Plan Maker" video button (top bar) — paste its YouTube link here once available.
// Left empty on purpose: the button is in place, the popup shows no video until then.
export const FLOOR_PLAN_MAKER_TUTORIAL_URL = '';

// Turns a pasted link into something an <iframe> or <video> can play.
export const toVideoSource = (url) => {
  if (!url) return null;
  const u = String(url).trim();
  if (!u) return null;
  const yt = u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  if (yt) return { type: 'iframe', src: `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0` };
  if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(u)) return { type: 'video', src: u };
  return { type: 'iframe', src: u };
};

// Plain, shareable page for the same video (what "Open in new tab" opens) —
// a YouTube link becomes its normal watch page instead of the embed player.
export const toVideoNewTabUrl = (url) => {
  const src = toVideoSource(url);
  if (!src) return null;
  const yt = String(src.src).match(/youtube\.com\/embed\/([A-Za-z0-9_-]{11})/);
  return yt ? `https://www.youtube.com/watch?v=${yt[1]}` : src.src;
};
